__turbopack_context__.v({
  "bondTab": "bondTypes-module-scss-module__MMDWTW__bondTab",
});
